module.exports = __webpack_public_path__ + "static/media/feedback.84a25d6f.svg";